import React, { useEffect, FC } from 'react'
import { useIntl } from 'react-intl'
import { usePrevious } from '../../../../../hooks/use-previous'
import { SingleSelectComboboxObject } from '../../../../../legacy-design-system/combobox'
import { VulnerabilitySubStatus } from '../../api/shared'
import { TRACE_STATUSES } from '../legacy-constants'
import { IntegrationRowProps } from './integration-row'

export const VulnerabilitySubstatusField: FC<IntegrationRowProps> = ({
  update,
  integrationValue
}) => {
  const { formatMessage } = useIntl()

  const vulnerabilityStatusName =
    typeof integrationValue.trace_status !== 'string'
      ? integrationValue.trace_status?.value
      : integrationValue.trace_status
  const previousVulnerabilityStatusName = usePrevious(vulnerabilityStatusName)

  // Reset if the ticket status changes, ignore the initial string population
  useEffect(() => {
    if (
      typeof integrationValue.trace_status === 'object' &&
      previousVulnerabilityStatusName !== vulnerabilityStatusName
    ) {
      update({ ...integrationValue, trace_substatus: undefined })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [previousVulnerabilityStatusName, vulnerabilityStatusName])

  return (
    <>
      <SingleSelectComboboxObject<VulnerabilitySubStatus>
        items={[
          {
            items: TRACE_STATUSES
          }
        ]}
        itemToString={(item) =>
          item.translationId ? formatMessage({ id: item.translationId }) : ''
        }
        disabled={
          !integrationValue.trace_status ||
          typeof integrationValue.trace_status === 'string' ||
          integrationValue.trace_status.value !== 'NotAProblem'
        }
        onChange={(value) =>
          update({ ...integrationValue, trace_substatus: value })
        }
        aria-label={formatMessage({
          id: 'title_integrationsSettings_vulnerabilityReason'
        })}
        value={
          integrationValue.trace_substatus &&
          typeof integrationValue.trace_substatus !== 'string'
            ? integrationValue.trace_substatus
            : undefined
        }
      />
    </>
  )
}
